import { render, staticRenderFns } from "./DocumentHeaderStatus.vue?vue&type=template&id=1f041cac&scoped=true&lang=pug&"
import script from "./DocumentHeaderStatus.vue?vue&type=script&lang=js&"
export * from "./DocumentHeaderStatus.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHeaderStatus.vue?vue&type=style&index=0&id=1f041cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f041cac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
